import type { TFunction } from 'i18next'

/**
 * Parses raw SSO error messages and returns the appropriate translated message
 */
export const getSsoErrorTranslation = (
  errorMessage: string,
  t: TFunction,
): string => {
  if (!errorMessage || typeof errorMessage !== 'string') {
    return t('loginView_ssoGenericError')
  }

  if (
    errorMessage.includes('User does not exist in backoffice user management')
  ) {
    return t('loginView_ssoUserNotFound')
  }

  if (
    errorMessage.includes(
      'There is already a user account for this email address that uses a different authentication method',
    )
  ) {
    return t('loginView_ssoDifferentAuthMethod')
  }

  return t('loginView_ssoGenericError')
}
